import { BREAKPOINT } from "utils/styles";
import { AUDIENCE_TYPES } from "posts/constants";
import Button from "components/Button";
import React from "react";
import ZeroStateAudienceCard from "components/HomepageAudienceCard/ZeroStateAudienceCard";
import styled from "styled-components";

const ZeroStateWrapper = styled.div`
  margin-top: 10rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  @media ${BREAKPOINT.M} {
    margin-top: 5rem;
    //  padding: 1rem;
  }
`;

const ZeroStateHeading = styled.h1`
  margin-bottom: 3rem;
  @media ${BREAKPOINT.M} {
    font-size: 2rem;
    padding-left: 0.5rem;
  }
`;

const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: 1rem;
  margin: 0 auto;
  max-width: 70rem;
  padding-left: 1rem;
  padding-right: 2rem;
  @media ${BREAKPOINT.M} {
    padding-right: 0rem;
    padding-left: 0rem;
  }
  @media (min-width: 55em) {
    grid-template-columns: 50% 50%;
  }
`;

export default function ZeroState({ title, urlPrefix }) {
  return (
    <ZeroStateWrapper>
      <ZeroStateHeading>{title}</ZeroStateHeading>
      <div>
        <ProfileGrid>
          <ZeroStateAudienceCard
            urlPrefix={urlPrefix}
            audience={AUDIENCE_TYPES.PEOPLE_POWER}
          />
          <ZeroStateAudienceCard
            urlPrefix={urlPrefix}
            audience={AUDIENCE_TYPES.IF_YOU_SAY_SO}
          />
          <ZeroStateAudienceCard
            urlPrefix={urlPrefix}
            audience={AUDIENCE_TYPES.TOUGH_COOKIES}
          />
          <ZeroStateAudienceCard
            urlPrefix={urlPrefix}
            audience={AUDIENCE_TYPES.DONT_TREAD_ON_ME}
          />
        </ProfileGrid>
      </div>
    </ZeroStateWrapper>
  );
}
